import { render, staticRenderFns } from "./SpFieldDetails.vue?vue&type=template&id=799bea5a&"
import script from "./SpFieldDetails.vue?vue&type=script&lang=ts&"
export * from "./SpFieldDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SpFieldDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports